/**
 * Versão única do Graph API da Meta, compartilhada por backend (WhatsApp,
 * Instagram, voz) e frontend (`FB.init` do Embedded Signup).
 *
 * Constante de código, e não env: subir a versão é decisão de release — exige
 * revalidar envio de template e chamadas de voz — não algo que se troque por
 * ambiente. Manter num só lugar evita o drift que existia antes, com v22.0
 * repetido em 8 arquivos entre os dois apps.
 *
 * v25.0 é o mínimo exigido pelo modo de coexistência do WhatsApp.
 *
 * `apps/wa-proxy` mantém uma cópia local desta versão (não compartilha o
 * workspace); ao subir aqui, subir lá também.
 */
export const GRAPH_API_VERSION = "v25.0";

export const GRAPH_API_BASE_URL = `https://graph.facebook.com/${GRAPH_API_VERSION}`;
